
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Facebook')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M438.05,619.13V427.39H502l12.16-79.31h-76.1V296.6c0-21.7,10.63-42.85,44.72-42.85h34.6V186.23s-31.4-5.36-61.43-5.36c-62.67,0-103.64,38-103.64,106.75v60.46H282.63v79.31H352.3V619.13Z","transform":"translate(0 0)"}})])])
          )
        }
      }
    